import { theme } from 'theme/App.theme';
import makeStyles from '@mui/styles/makeStyles';
import { appFonts } from 'theme/App.fonts';
import { appPalette } from 'theme/App.palette';

const { honda_blue } = appPalette.colors;
export const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  back_to_container: {
    margin: '1.25rem 0.9375rem 1.25rem 1.875rem',
  },
  back_to_link: {
    display: 'inline',
    textDecoration: 'none',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontFamily: appFonts.AvenirNextDemi.fontFamily,
    fontSize: '0.875rem',
    letterSpacing: 'normal',
    lineHeight: '1.25rem',
    borderBottom: '0',
    color: 'inherit',
    ...(theme.themeName === 'honda' && {
      fontFamily: 'AvenirNext-DemiBold, AvenirNextSemiBold',
      textTransform: 'none',
      letterSpacing: '0.01875rem',
      color: honda_blue,
    }),
  },
  back_to_link_icon: {
    height: '0.75rem !important',
    width: '0.5rem  !important',
    marginRight: '0.5rem',
    paddingTop: '0.0625rem',
    ...(theme.themeName === 'honda' && {
      marginRight: '0.3125rem',
    }),
  },
  dealerMapContainer: {
    height: '13.4375rem',
    marginBottom: '1.875rem',
    [theme.breakpoints.up('viewportMedium')]: {
      height: '62.5rem',
    },
    [theme.breakpoints.up('viewportLarge')]: {
      paddingLeft: '1.375rem',
    },
    [theme.breakpoints.up('viewportXLarge')]: {
      paddingLeft: '2rem',
    },
  },
  dealerInfoContainer: {
    marginBottom: '1.875rem',
    [theme.breakpoints.up('viewportMedium')]: {
      padding: '0 0.5rem !important',
    },
    [theme.breakpoints.up('viewportLarge')]: {
      maxWidth: '42%',
      minWidth: '28.4375rem',
    },
  },
});
